import React, { useEffect } from 'react';
import { toast, useToasterStore } from 'react-hot-toast';
import PropTypes from 'prop-types';

import ExpiredSession from './ExpiredSession';
import { Overlay, Wrapper } from './styles';

const ALERT_DURATION = 4_000;

function CustomToast({ isOpen, close, type }) {
  const { toasts } = useToasterStore();

  const handleClose = async () => {
    toast.remove();
    close();
  };

  const timerClose = () => {
    setTimeout(() => {
      handleClose();
    }, ALERT_DURATION);
  };

  useEffect(() => {
    timerClose();
    return () => {
      clearTimeout(timerClose);
    };
  }, []);

  const toastCollection = {
    sessionExpired: () => (
      <ExpiredSession timerClose={timerClose} close={handleClose} />
    ),
  };
  useEffect(() => {
    if (!toasts.length && isOpen) {
      toast(({ id }) => toastCollection[type](id), {
        className: 'expired-session-popup',
        duration: Infinity,
        position: 'top-center',
      });
    }
  }, [close]);

  return (
    <Wrapper
      onClick={() => {
        close();
        toast.remove();
      }}
    >
      <Overlay isOpen={isOpen} />
    </Wrapper>
  );
}

CustomToast.propTypes = {
  close: PropTypes.func,
  isOpen: PropTypes.bool,
  type: PropTypes.string,
};

export default CustomToast;
